import { ReactElement } from 'react';
import {
    UIIcon,
    UIIconName,
    UIPressableArea,
    UIPressableAreaVariant
} from '../..';
import { charcoal } from '../../styles';

type UIIconButtonProps = {
    icon: UIIconName;
    iconColor?: string;
    variant?: UIPressableAreaVariant;
    type?: 'button' | 'reset' | 'submit';
    small?: boolean;
    onClick: () => void;
};
export function UIIconButton(props: UIIconButtonProps): ReactElement {
    const { icon, iconColor = charcoal, small = false } = props;

    const size = small ? 14 : 18;
    const padding = small ? 6 : undefined;

    return (
        <UIPressableArea {...props} padding={padding}>
            {() => <UIIcon name={icon} size={size} color={iconColor} />}
        </UIPressableArea>
    );
}
